// @ts-nocheck

export function generateHeaderRows(translate, headerRowGenerator) {
  if (headerRowGenerator) {
    return headerRowGenerator();
  }
  let headerRows = [];
  let firstHeaderRow = {
    className: "main-header",
    headers: [
      {
        id: "label",
        key: "label",
        colSpan: 1,
        name: "",
        className: "no-border right-align",
      },
      ...[
        {
          id: "chf",
          key: "chf",
          colSpan: 1,
          name: "CHF",
          className: "bold-header no-border",
        },
        {
          id: "pctOfGrossSalary",
          key: "pctOfGrossSalary",
          colSpan: 1,
          name: translate(`benchmarking.calculations-page.table.${"pctOfGrossSalary"}`),
          className: "bold-header no-border",
        },
        {
          id: "pctOfSelfCosts",
          key: "pctOfSelfCosts",
          colSpan: 1,
          name: translate(`benchmarking.calculations-page.table.${"pctOfSelfCosts"}`),
          className: "bold-header no-border",
        },
      ],
    ],
  };
  headerRows.push(firstHeaderRow);
  return headerRows;
}
